import axios from "axios";
import fetchJsonp from "fetch-jsonp";
export const beezerApi = (url: string) => fetchJsonp(`https://api.deezer.com/${url}&index=0&limit=30&output=jsonp`);
export const baseBeezer = axios.create({
    baseURL: "https://deezerdevs-deezer.p.rapidapi.com/",
    headers: {
        'X-RapidAPI-Host': 'deezerdevs-deezer.p.rapidapi.com',
        'X-RapidAPI-Key': '9337d42b45mshc66991d09933aa7p12e94bjsnfb5b65914fac'
    }
});
